<div  *ngIf="loader" class="spinner-wrapper">
    <mis-loader [mobileView]="false"></mis-loader>
</div>
<div  *ngIf="!loader" class="main d-flex">
<app-side-view-cab *ngIf="cardDataLoaded" [adhoc_text]="adhoc_text"></app-side-view-cab>
<app-map-view></app-map-view>

</div>